import { render, staticRenderFns } from "./side-icon-select.vue?vue&type=template&id=fe1a037e&scoped=true&"
import script from "./side-icon-select.vue?vue&type=script&lang=js&"
export * from "./side-icon-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1a037e",
  null
  
)

export default component.exports